export default {
  name: 'MStepLayout',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'md',
      validator: val => ['sm', 'md', 'lg'].indexOf(val) !== -1,
    },
  },
  computed: {
    hasDescription() {
      return (
        this.description !== '' || Object.prototype.hasOwnProperty.call(this.$slots, 'description')
      );
    },
  },
};
